<template>
  <modal v-if="userId"
         closeCrossColor="#ccc"
         @close="close">
    <div class="events__modal text-dark" slot="body">
      <div class="events__modal__header">
        <h2>{{userName}}</h2>
        <h3><span v-if="eventsFilter === 'absence'">{{ $t('vue2.user_event_list.absence') }}</span> <span v-if="eventsFilter === 'subject'">{{ $t('vue2.user_event_list.teaching') }}</span><span v-if="eventsFilter === 'substituteHours'">{{ $t('vue2.user_event_list.substitute_hours') }}</span>  {{ $t('vue2.user_event_list.from') }} {{start | LL}} {{ $t('vue2.user_event_list.to') }} {{end | LL}}</h3>
      </div>
      <div class="events__modal__body">
        <Loader v-if="isLoading" bg-color="#f6f9fc"></Loader>
        <template v-else>
          <h4 class="text--explainer" v-if="filteredEvents.length < 1">{{ $t('vue2.user_event_list.no_matching_events') }}</h4>
          <ul class="events__list">
            <li v-for="event in sortedEvents" :key="event.event_id">
              <p>{{event.start_time | ddd | capitalize}} {{event.start_time | LL }} kl. {{ event.start_time | LT }} -
                {{event.end_time | LT }}, {{event.title}}</p>
              <p>{{getDuration(event)}}</p>
            </li>
            <li><b>{{ $t('vue2.user_event_list.total') }}</b> <b>{{totalDuration}}</b></li>
          </ul>
        </template>
      </div>
      <div class="events__modal__footer">
        <button @click="close">{{ $t('vue2.user_event_list.close') }}</button>
      </div>
    </div>
  </modal>
</template>

<script>
  import Modal from '../Subjects/Modal'
  import docendo from '../../docendo'
  import moment from 'moment'
  import filters from '../../filters/filters' // eslint-disable-line no-unused-vars
  import Loader from '../common/Loader'

  export default {
    components: {Loader, Modal},
    props: {
      userId: {
        type: Number
      },
      eventsFilter: {
        type: String,
        default: 'absence'
      }
    },
    data () {
      return {
        showModal: false,
        events: [],
        isLoading: false
      }
    },
    computed: {
      activeSchoolYears () {
        return this.$store.state.localActivatedSchoolYear
      },
      start () {
        return moment(this.activeSchoolYears.employee_time_start).startOf('day')
      },
      end () {
        return moment(this.activeSchoolYears.employee_time_end).startOf('day')
      },
      allUsersInHash () {
        return this.$store.getters.allUsersInHash
      },
      selectedUsersIds () {
        return [this.userId]
      },
      userName () {
        return this.allUsersInHash[this.userId] ? this.allUsersInHash[this.userId].name : ''
      },
      filteredEvents () {
        return this.events.filter(obj => {
          switch (this.eventsFilter) {
            case null:
              return obj.event_type !== ''
            case 'subject':
              return obj.event_type !== 'absence' && obj.event_type !== 'other_tasks' && obj.event_type !== 'other_stuff' && obj.substitute_for === null
            case 'substituteHours':
              return obj.substitute_for !== null
            case 'absence':
              return obj.event_type === 'absence'
          }
        })
      },
      sortedEvents () {
        let arr = this.filteredEvents
        return arr.sort((a, b) => {
          return moment(a.start_time).unix() - moment(b.start_time).unix()
        })
      },
      totalDuration () {
        let durations = []
        this.sortedEvents.forEach(event => {
          durations.push(event.user_teaching_mins)
        })
        let data = durations.reduce((a, b) => a + b, 0)
        return this.humanizeMinutes(data)
      }
    },
    watch: {
      userId () {
        this.getAllEvents()
      }
    },
    methods: {
      getAllEvents () {
        this.isLoading = true
        docendo.schoolEvents(window.SCHOOL.id, this.start, this.end, this.selectedUsersIds, 'absence', (data) => {
          this.events = data[0].events
          this.isLoading = false
        })
      },
      getDuration (event) {
        return this.humanizeMinutes(event.user_teaching_mins)
      },
      humanizeMinutes (data) {
        const minutes = data % 60
        const hours = (data - minutes) / 60
        const multiple = hours === 1 ? this.$i18n.t('vue2.substitute_hours.hour') : this.$i18n.t('vue2.substitute_hours.hours')
        return hours + ' ' + multiple + ' ' + minutes + ' ' + this.$t('vue2.substitute_hours.min')
      },
      close () {
        this.$emit('close')
        this.events = []
      }
    },
    mounted () {
      this.getAllEvents()
    }
  }
</script>
<style scoped>
  .events__modal__header {
    position: relative;
    background-color: #ffffff;
    padding: 30px 20px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid #e2e8f0;
  }

  .events__modal__header > h2 {
    margin-top: 0;
  }

  .events__modal__body {
    position: relative;
    overflow-y: scroll;
    max-height: calc(100vh - 10vh - 120px); /* 120px is modal header; 10vh is modal from vtop */
  }

  .events__modal__footer {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
    border-top: 1px solid #e2e8f0;
  }

  .events__modal__body h4 {
    padding: 20px;
  }

  .events__list > li {
    padding: 5px 20px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
  }

  .events__list > li:nth-child(odd) {
    background-color: #f8fafb;
  }
</style>



// WEBPACK FOOTER //
// UserEventList.vue?ce7c4060